import { render, staticRenderFns } from "./preview-accessory.vue?vue&type=template&id=fa9e861a&scoped=true"
import script from "./preview-accessory.vue?vue&type=script&lang=js"
export * from "./preview-accessory.vue?vue&type=script&lang=js"
import style0 from "./preview-accessory.vue?vue&type=style&index=0&id=fa9e861a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9e861a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa9e861a')) {
      api.createRecord('fa9e861a', component.options)
    } else {
      api.reload('fa9e861a', component.options)
    }
    module.hot.accept("./preview-accessory.vue?vue&type=template&id=fa9e861a&scoped=true", function () {
      api.rerender('fa9e861a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/preview-accessory.vue"
export default component.exports